import React from "react"
import { useParams } from "react-router-dom"
import { EdicaoClienteContextProvider } from "./context/EdicaoClienteContextProvider"
import { EdicaoCliente } from "./EdicaoCliente"

export function Index() {
    const { idCliente } = useParams<{ idCliente: string }>()

    return (
        <EdicaoClienteContextProvider idCliente={Number(idCliente)}>
            <EdicaoCliente />
        </EdicaoClienteContextProvider>
    )
}
